/**
 * Helper component for returning an array of vnodes from a view function
 *
 * @example
 * import {Fragment} from '@servicenow/ui-renderer-snabbdom';
 *
 * function view(state, dispatch) {
 *     return (
 *         <Fragment>
 *             <div>Foo</div>
 *             <div>Bar</div>
 *             <div>Baz</div>
 *         </Fragment>
 *     );
 * }
 *
 * @method Fragment
 * @param props
 * @param children
 * @returns {*}
 */
export default function Fragment(props, children) {
	return children;
}
